import Post from "../components/templates/Post";
import Logo from "../components/templates/Logo";
import Navigation from "../components/templates/Navigation";
import PostEditor from "../components/editors/PostEditor";
import LogoEditor from "../components/editors/LogoEditor";
import NavigationEditor from "../components/editors/NavigationEditor";
import Widget, {WidgetModelInterface} from "./Widget";
import {observable} from "mobx";
import Title from "../components/templates/Title";
import TitleEditor from "../components/editors/TitleEditor";


class WidgetsStore {

    @observable items: Map<string, any> = new Map<string, any>();

    constructor() {
        this.init();
    }

    init() {

        this.items.set('Title', {
            template: Title,
            editor: TitleEditor
        });

        this.items.set('Post', {
            template: Post,
            editor: PostEditor
        });

        this.items.set('Navigation', {
            template: Navigation,
            editor: NavigationEditor
        });

        this.items.set('Logo', {
            template: Logo,
            editor: LogoEditor
        });

    }

    createWidget(widgetModel: WidgetModelInterface): Widget {
        const widget = new Widget(widgetModel);
        const type = widget.config.type;

        //#TODO add check if template or editor is exist
        widget.setEditorComponent(this.items.get(type).editor);
        widget.setTemplateComponent(this.items.get(type).template);

        return widget;
    }
}

export default WidgetsStore;
